import JobApplicationForm from "../../../../components/forms/jobApplicationForm";
import { useSelector } from "react-redux";
import { useGetCvFormQuery } from "../../../../features/user/userApiSlice";

const CreateJobApplication = () => {
  const { name } = useSelector((state) => state.user);
  // Ensure CV is available after template select (cache + refetch)
  useGetCvFormQuery(name?._id, {
    skip: !name?._id,
    refetchOnMountOrArgChange: true,
  });

  return (
    <div>
      <JobApplicationForm butn="Post" back="/CV-Form" />
    </div>
  );
};
export default CreateJobApplication;
